import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { WorkOrdersRepository } from '../workorders.repository';
import { WorkOrdersQuery } from '../state/workorders.query';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-workorders-search',
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    MatIconModule,
    MatButtonModule,
    TranslateModule,
  ],
  templateUrl: './workorders-search.component.html',
  styleUrls: ['./workorders-search.component.scss'],
})
export class WorkordersSearchComponent {
  searchTerm: string | null;

  constructor(private repo: WorkOrdersRepository, private workOrdersQuery: WorkOrdersQuery) {
    this.searchTerm = this.workOrdersQuery.searchTerm;
  }

  updateSearchText(value?: string) {
    this.repo.updateSearchTerm(value);
  }
}
